function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
var _Symbol$for;
function _classPrivateFieldLooseBase(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
    throw new TypeError("attempted to use private field on non-instance");
  }
  return receiver;
}
var id = 0;
function _classPrivateFieldLooseKey(name) {
  return "__private_" + id++ + "_" + name;
}
import BasePlugin from '@uppy/core/lib/BasePlugin.js';
import { RequestClient } from '@uppy/companion-client';
import EventManager from '@uppy/core/lib/EventManager.js';
import { RateLimitedQueue } from '@uppy/utils/lib/RateLimitedQueue';
import { filterNonFailedFiles, filterFilesToEmitUploadStarted } from '@uppy/utils/lib/fileFilters';
import { createAbortError } from '@uppy/utils/lib/AbortController';
import MultipartUploader from "./MultipartUploader.js";
import { throwIfAborted } from "./utils.js";
import _createSignedURL from "./createSignedURL.js";
import { HTTPCommunicationQueue } from "./HTTPCommunicationQueue.js";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore We don't want TS to generate types for the package.json
var packageJson = {
  "version": "3.12.0"
};
function assertServerError(res) {
  if (res != null && res.error) {
    var error = new Error(res.message);
    Object.assign(error, res.error);
    throw error;
  }
  return res;
}
/**
 * Computes the expiry time for a request signed with temporary credentials. If
 * no expiration was provided, or an invalid value (e.g. in the past) is
 * provided, undefined is returned. This function assumes the client clock is in
 * sync with the remote server, which is a requirement for the signature to be
 * validated for AWS anyway.
 */
function getExpiry(credentials) {
  var expirationDate = credentials.Expiration;
  if (expirationDate) {
    var timeUntilExpiry = Math.floor((new Date(expirationDate) - Date.now()) / 1000);
    if (timeUntilExpiry > 9) {
      return timeUntilExpiry;
    }
  }
  return undefined;
}
function getAllowedMetadata(_ref) {
  var meta = _ref.meta,
    allowedMetaFields = _ref.allowedMetaFields,
    _ref$querify = _ref.querify,
    querify = _ref$querify === void 0 ? false : _ref$querify;
  var metaFields = allowedMetaFields != null ? allowedMetaFields : Object.keys(meta);
  if (!meta) return {};
  return Object.fromEntries(metaFields.filter(function (key) {
    return meta[key] != null;
  }).map(function (key) {
    var realKey = querify ? "metadata[".concat(key, "]") : key;
    var value = String(meta[key]);
    return [realKey, value];
  }));
}

/** @deprecated Use signPart instead */

var defaultOptions = {
  // TODO: null here means “include all”, [] means include none.
  // This is inconsistent with @uppy/aws-s3 and @uppy/transloadit
  allowedMetaFields: null,
  limit: 6,
  getTemporarySecurityCredentials: false,
  shouldUseMultipart: function shouldUseMultipart(file) {
    return file.size !== 0;
  },
  // TODO: Switch default to:
  // eslint-disable-next-line no-bitwise
  // shouldUseMultipart: (file) => file.size >> 10 >> 10 > 100,
  retryDelays: [0, 1000, 3000, 5000],
  companionHeaders: {}
};
var _companionCommunicationQueue = /*#__PURE__*/_classPrivateFieldLooseKey("companionCommunicationQueue");
var _client = /*#__PURE__*/_classPrivateFieldLooseKey("client");
var _cachedTemporaryCredentials = /*#__PURE__*/_classPrivateFieldLooseKey("cachedTemporaryCredentials");
var _getTemporarySecurityCredentials = /*#__PURE__*/_classPrivateFieldLooseKey("getTemporarySecurityCredentials");
var _setS3MultipartState = /*#__PURE__*/_classPrivateFieldLooseKey("setS3MultipartState");
var _getFile = /*#__PURE__*/_classPrivateFieldLooseKey("getFile");
var _uploadLocalFile = /*#__PURE__*/_classPrivateFieldLooseKey("uploadLocalFile");
var _getCompanionClientArgs = /*#__PURE__*/_classPrivateFieldLooseKey("getCompanionClientArgs");
var _upload = /*#__PURE__*/_classPrivateFieldLooseKey("upload");
var _setCompanionHeaders = /*#__PURE__*/_classPrivateFieldLooseKey("setCompanionHeaders");
var _setResumableUploadsCapability = /*#__PURE__*/_classPrivateFieldLooseKey("setResumableUploadsCapability");
var _resetResumableCapability = /*#__PURE__*/_classPrivateFieldLooseKey("resetResumableCapability");
_Symbol$for = Symbol.for('uppy test: getClient');
var AwsS3Multipart = /*#__PURE__*/function (_BasePlugin, _Symbol$for2) {
  _inherits(AwsS3Multipart, _BasePlugin);
  function AwsS3Multipart(uppy, opts) {
    var _this2;
    _classCallCheck(this, AwsS3Multipart);
    var _rateLimitedQueue;
    _this2 = _callSuper(this, AwsS3Multipart, [uppy, _objectSpread(_objectSpread({}, defaultOptions), {}, {
      uploadPartBytes: AwsS3Multipart.uploadPartBytes,
      createMultipartUpload: null,
      listParts: null,
      abortMultipartUpload: null,
      completeMultipartUpload: null,
      signPart: null,
      getUploadParameters: null
    }, opts)]);
    // We need the `as any` here because of the dynamic default options.
    // eslint-disable-next-line class-methods-use-this
    Object.defineProperty(_assertThisInitialized(_this2), _getCompanionClientArgs, {
      value: _getCompanionClientArgs2
    });
    Object.defineProperty(_assertThisInitialized(_this2), _uploadLocalFile, {
      value: _uploadLocalFile2
    });
    Object.defineProperty(_assertThisInitialized(_this2), _getTemporarySecurityCredentials, {
      value: _getTemporarySecurityCredentials2
    });
    Object.defineProperty(_assertThisInitialized(_this2), _companionCommunicationQueue, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(_assertThisInitialized(_this2), _client, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(_assertThisInitialized(_this2), _cachedTemporaryCredentials, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(_assertThisInitialized(_this2), _setS3MultipartState, {
      writable: true,
      value: function value(file, _ref2) {
        var key = _ref2.key,
          uploadId = _ref2.uploadId;
        var cFile = _this2.uppy.getFile(file.id);
        if (cFile == null) {
          // file was removed from store
          return;
        }
        _this2.uppy.setFileState(file.id, {
          s3Multipart: _objectSpread(_objectSpread({}, cFile.s3Multipart), {}, {
            key: key,
            uploadId: uploadId
          })
        });
      }
    });
    Object.defineProperty(_assertThisInitialized(_this2), _getFile, {
      writable: true,
      value: function value(file) {
        return _this2.uppy.getFile(file.id) || file;
      }
    });
    Object.defineProperty(_assertThisInitialized(_this2), _upload, {
      writable: true,
      value: function () {
        var _value = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(fileIDs) {
          var files, filesFiltered, filesToEmit, promises, upload;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                if (!(fileIDs.length === 0)) {
                  _context.next = 2;
                  break;
                }
                return _context.abrupt("return", undefined);
              case 2:
                files = _this2.uppy.getFilesByIds(fileIDs);
                filesFiltered = filterNonFailedFiles(files);
                filesToEmit = filterFilesToEmitUploadStarted(filesFiltered);
                _this2.uppy.emit('upload-start', filesToEmit);
                promises = filesFiltered.map(function (file) {
                  if (file.isRemote) {
                    var getQueue = function getQueue() {
                      return _this2.requests;
                    };
                    _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _setResumableUploadsCapability)[_setResumableUploadsCapability](false);
                    var controller = new AbortController();
                    var removedHandler = function removedHandler(removedFile) {
                      if (removedFile.id === file.id) controller.abort();
                    };
                    _this2.uppy.on('file-removed', removedHandler);
                    var uploadPromise = _this2.uppy.getRequestClientForFile(file).uploadRemoteFile(file, _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _getCompanionClientArgs)[_getCompanionClientArgs](file), {
                      signal: controller.signal,
                      getQueue: getQueue
                    });
                    _this2.requests.wrapSyncFunction(function () {
                      _this2.uppy.off('file-removed', removedHandler);
                    }, {
                      priority: -1
                    })();
                    return uploadPromise;
                  }
                  return _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _uploadLocalFile)[_uploadLocalFile](file);
                });
                _context.next = 9;
                return Promise.all(promises);
              case 9:
                upload = _context.sent;
                // After the upload is done, another upload may happen with only local files.
                // We reset the capability so that the next upload can use resumable uploads.
                _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _setResumableUploadsCapability)[_setResumableUploadsCapability](true);
                return _context.abrupt("return", upload);
              case 12:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        function value(_x) {
          return _value.apply(this, arguments);
        }
        return value;
      }()
    });
    Object.defineProperty(_assertThisInitialized(_this2), _setCompanionHeaders, {
      writable: true,
      value: function value() {
        _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _client)[_client].setCompanionHeaders(_this2.opts.companionHeaders);
      }
    });
    Object.defineProperty(_assertThisInitialized(_this2), _setResumableUploadsCapability, {
      writable: true,
      value: function value(boolean) {
        var _this2$uppy$getState = _this2.uppy.getState(),
          capabilities = _this2$uppy$getState.capabilities;
        _this2.uppy.setState({
          capabilities: _objectSpread(_objectSpread({}, capabilities), {}, {
            resumableUploads: boolean
          })
        });
      }
    });
    Object.defineProperty(_assertThisInitialized(_this2), _resetResumableCapability, {
      writable: true,
      value: function value() {
        _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _setResumableUploadsCapability)[_setResumableUploadsCapability](true);
      }
    });
    _this2.type = 'uploader';
    _this2.id = _this2.opts.id || 'AwsS3Multipart';
    // @ts-expect-error TODO: remove unused
    _this2.title = 'AWS S3 Multipart';
    // TODO: only initiate `RequestClient` is `companionUrl` is defined.
    _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _client)[_client] = new RequestClient(uppy, opts);
    var dynamicDefaultOptions = {
      createMultipartUpload: _this2.createMultipartUpload,
      listParts: _this2.listParts,
      abortMultipartUpload: _this2.abortMultipartUpload,
      completeMultipartUpload: _this2.completeMultipartUpload,
      signPart: opts != null && opts.getTemporarySecurityCredentials ? _this2.createSignedURL : _this2.signPart,
      getUploadParameters: opts != null && opts.getTemporarySecurityCredentials ? _this2.createSignedURL : _this2.getUploadParameters
    };
    for (var _i = 0, _Object$keys = Object.keys(dynamicDefaultOptions); _i < _Object$keys.length; _i++) {
      var key = _Object$keys[_i];
      if (_this2.opts[key] == null) {
        _this2.opts[key] = dynamicDefaultOptions[key].bind(_assertThisInitialized(_this2));
      }
    }
    if ((opts == null ? void 0 : opts.prepareUploadParts) != null && opts.signPart == null) {
      _this2.opts.signPart = /*#__PURE__*/function () {
        var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(file, _ref3) {
          var uploadId, key, partNumber, body, signal, _yield$opts$prepareUp, presignedUrls, headers;
          return _regeneratorRuntime().wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                uploadId = _ref3.uploadId, key = _ref3.key, partNumber = _ref3.partNumber, body = _ref3.body, signal = _ref3.signal;
                _context2.next = 3;
                return opts.prepareUploadParts(file, {
                  uploadId: uploadId,
                  key: key,
                  parts: [{
                    number: partNumber,
                    chunk: body
                  }],
                  signal: signal
                });
              case 3:
                _yield$opts$prepareUp = _context2.sent;
                presignedUrls = _yield$opts$prepareUp.presignedUrls;
                headers = _yield$opts$prepareUp.headers;
                return _context2.abrupt("return", {
                  url: presignedUrls == null ? void 0 : presignedUrls[partNumber],
                  headers: headers == null ? void 0 : headers[partNumber]
                });
              case 7:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        }));
        return function (_x2, _x3) {
          return _ref9.apply(this, arguments);
        };
      }();
    }

    /**
     * Simultaneous upload limiting is shared across all uploads with this plugin.
     *
     * @type {RateLimitedQueue}
     */
    _this2.requests = (_rateLimitedQueue = _this2.opts.rateLimitedQueue) != null ? _rateLimitedQueue : new RateLimitedQueue(_this2.opts.limit);
    _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _companionCommunicationQueue)[_companionCommunicationQueue] = new HTTPCommunicationQueue(_this2.requests, _this2.opts, _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _setS3MultipartState)[_setS3MultipartState], _classPrivateFieldLooseBase(_assertThisInitialized(_this2), _getFile)[_getFile]);
    _this2.uploaders = Object.create(null);
    _this2.uploaderEvents = Object.create(null);
    _this2.uploaderSockets = Object.create(null);
    return _this2;
  }
  _createClass(AwsS3Multipart, [{
    key: _Symbol$for2,
    value: function value() {
      return _classPrivateFieldLooseBase(this, _client)[_client];
    }
  }, {
    key: "setOptions",
    value: function setOptions(newOptions) {
      _classPrivateFieldLooseBase(this, _companionCommunicationQueue)[_companionCommunicationQueue].setOptions(newOptions);
      _get(_getPrototypeOf(AwsS3Multipart.prototype), "setOptions", this).call(this, newOptions);
      _classPrivateFieldLooseBase(this, _setCompanionHeaders)[_setCompanionHeaders]();
    }

    /**
     * Clean up all references for a file's upload: the MultipartUploader instance,
     * any events related to the file, and the Companion WebSocket connection.
     *
     * Set `opts.abort` to tell S3 that the multipart upload is cancelled and must be removed.
     * This should be done when the user cancels the upload, not when the upload is completed or errored.
     */
  }, {
    key: "resetUploaderReferences",
    value: function resetUploaderReferences(fileID, opts) {
      if (this.uploaders[fileID]) {
        this.uploaders[fileID].abort({
          really: (opts == null ? void 0 : opts.abort) || false
        });
        this.uploaders[fileID] = null;
      }
      if (this.uploaderEvents[fileID]) {
        this.uploaderEvents[fileID].remove();
        this.uploaderEvents[fileID] = null;
      }
      if (this.uploaderSockets[fileID]) {
        // @ts-expect-error TODO: remove this block in the next major
        this.uploaderSockets[fileID].close();
        // @ts-expect-error TODO: remove this block in the next major
        this.uploaderSockets[fileID] = null;
      }
    }

    // TODO: make this a private method in the next major
  }, {
    key: "assertHost",
    value: function assertHost(method) {
      if (!this.opts.companionUrl) {
        throw new Error("Expected a `companionUrl` option containing a Companion address, or if you are not using Companion, a custom `".concat(method, "` implementation."));
      }
    }
  }, {
    key: "createMultipartUpload",
    value: function createMultipartUpload(file, signal) {
      this.assertHost('createMultipartUpload');
      throwIfAborted(signal);
      var metadata = getAllowedMetadata({
        meta: file.meta,
        allowedMetaFields: this.opts.allowedMetaFields
      });
      return _classPrivateFieldLooseBase(this, _client)[_client].post('s3/multipart', {
        filename: file.name,
        type: file.type,
        metadata: metadata
      }, {
        signal: signal
      }).then(assertServerError);
    }
  }, {
    key: "listParts",
    value: function listParts(file, _ref4, oldSignal) {
      var _signal;
      var key = _ref4.key,
        uploadId = _ref4.uploadId,
        signal = _ref4.signal;
      (_signal = signal) != null ? _signal : signal = oldSignal; // eslint-disable-line no-param-reassign
      this.assertHost('listParts');
      throwIfAborted(signal);
      var filename = encodeURIComponent(key);
      return _classPrivateFieldLooseBase(this, _client)[_client].get("s3/multipart/".concat(uploadId, "?key=").concat(filename), {
        signal: signal
      }).then(assertServerError);
    }
  }, {
    key: "completeMultipartUpload",
    value: function completeMultipartUpload(file, _ref5, oldSignal) {
      var _signal2;
      var key = _ref5.key,
        uploadId = _ref5.uploadId,
        parts = _ref5.parts,
        signal = _ref5.signal;
      (_signal2 = signal) != null ? _signal2 : signal = oldSignal; // eslint-disable-line no-param-reassign
      this.assertHost('completeMultipartUpload');
      throwIfAborted(signal);
      var filename = encodeURIComponent(key);
      var uploadIdEnc = encodeURIComponent(uploadId);
      return _classPrivateFieldLooseBase(this, _client)[_client].post("s3/multipart/".concat(uploadIdEnc, "/complete?key=").concat(filename), {
        parts: parts
      }, {
        signal: signal
      }).then(assertServerError);
    }
  }, {
    key: "createSignedURL",
    value: function () {
      var _createSignedURL2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(file, options) {
        var data, expires, uploadId, key, partNumber;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _classPrivateFieldLooseBase(this, _getTemporarySecurityCredentials)[_getTemporarySecurityCredentials](options);
            case 2:
              data = _context3.sent;
              expires = getExpiry(data.credentials) || 604800; // 604 800 is the max value accepted by AWS.
              uploadId = options.uploadId, key = options.key, partNumber = options.partNumber; // Return an object in the correct shape.
              _context3.t0 = expires;
              _context3.t1 = {};
              _context3.t2 = "";
              _context3.next = 10;
              return _createSignedURL({
                accountKey: data.credentials.AccessKeyId,
                accountSecret: data.credentials.SecretAccessKey,
                sessionToken: data.credentials.SessionToken,
                expires: expires,
                bucketName: data.bucket,
                Region: data.region,
                Key: key != null ? key : "".concat(crypto.randomUUID(), "-").concat(file.name),
                uploadId: uploadId,
                partNumber: partNumber
              });
            case 10:
              _context3.t3 = _context3.sent;
              _context3.t4 = _context3.t2.concat.call(_context3.t2, _context3.t3);
              _context3.t5 = {
                'Content-Type': file.type
              };
              return _context3.abrupt("return", {
                method: 'PUT',
                expires: _context3.t0,
                fields: _context3.t1,
                url: _context3.t4,
                headers: _context3.t5
              });
            case 14:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function createSignedURL(_x4, _x5) {
        return _createSignedURL2.apply(this, arguments);
      }
      return createSignedURL;
    }()
  }, {
    key: "signPart",
    value: function signPart(file, _ref6) {
      var uploadId = _ref6.uploadId,
        key = _ref6.key,
        partNumber = _ref6.partNumber,
        signal = _ref6.signal;
      this.assertHost('signPart');
      throwIfAborted(signal);
      if (uploadId == null || key == null || partNumber == null) {
        throw new Error('Cannot sign without a key, an uploadId, and a partNumber');
      }
      var filename = encodeURIComponent(key);
      return _classPrivateFieldLooseBase(this, _client)[_client].get("s3/multipart/".concat(uploadId, "/").concat(partNumber, "?key=").concat(filename), {
        signal: signal
      }).then(assertServerError);
    }
  }, {
    key: "abortMultipartUpload",
    value: function abortMultipartUpload(file, _ref7,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    oldSignal // TODO: remove in next major
    ) {
      var _signal3;
      var key = _ref7.key,
        uploadId = _ref7.uploadId,
        signal = _ref7.signal;
      (_signal3 = signal) != null ? _signal3 : signal = oldSignal; // eslint-disable-line no-param-reassign
      this.assertHost('abortMultipartUpload');
      var filename = encodeURIComponent(key);
      var uploadIdEnc = encodeURIComponent(uploadId);
      return _classPrivateFieldLooseBase(this, _client)[_client].delete("s3/multipart/".concat(uploadIdEnc, "?key=").concat(filename), undefined, {
        signal: signal
      }).then(assertServerError);
    }
  }, {
    key: "getUploadParameters",
    value: function getUploadParameters(file, options) {
      var meta = file.meta;
      var type = meta.type,
        filename = meta.name;
      var metadata = getAllowedMetadata({
        meta: meta,
        allowedMetaFields: this.opts.allowedMetaFields,
        querify: true
      });
      var query = new URLSearchParams(_objectSpread({
        filename: filename,
        type: type
      }, metadata));
      return _classPrivateFieldLooseBase(this, _client)[_client].get("s3/params?".concat(query), options);
    }
  }, {
    key: "install",
    value: function install() {
      _classPrivateFieldLooseBase(this, _setResumableUploadsCapability)[_setResumableUploadsCapability](true);
      this.uppy.addPreProcessor(_classPrivateFieldLooseBase(this, _setCompanionHeaders)[_setCompanionHeaders]);
      this.uppy.addUploader(_classPrivateFieldLooseBase(this, _upload)[_upload]);
      this.uppy.on('cancel-all', _classPrivateFieldLooseBase(this, _resetResumableCapability)[_resetResumableCapability]);
    }
  }, {
    key: "uninstall",
    value: function uninstall() {
      this.uppy.removePreProcessor(_classPrivateFieldLooseBase(this, _setCompanionHeaders)[_setCompanionHeaders]);
      this.uppy.removeUploader(_classPrivateFieldLooseBase(this, _upload)[_upload]);
      this.uppy.off('cancel-all', _classPrivateFieldLooseBase(this, _resetResumableCapability)[_resetResumableCapability]);
    }
  }], [{
    key: "uploadPartBytes",
    value: function () {
      var _uploadPartBytes = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(_ref8) {
        var _ref8$signature, url, expires, headers, _ref8$signature$metho, method, body, _ref8$size, size, onProgress, onComplete, signal;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _ref8$signature = _ref8.signature, url = _ref8$signature.url, expires = _ref8$signature.expires, headers = _ref8$signature.headers, _ref8$signature$metho = _ref8$signature.method, method = _ref8$signature$metho === void 0 ? 'PUT' : _ref8$signature$metho, body = _ref8.body, _ref8$size = _ref8.size, size = _ref8$size === void 0 ? body.size : _ref8$size, onProgress = _ref8.onProgress, onComplete = _ref8.onComplete, signal = _ref8.signal;
              throwIfAborted(signal);
              if (!(url == null)) {
                _context4.next = 4;
                break;
              }
              throw new Error('Cannot upload to an undefined URL');
            case 4:
              return _context4.abrupt("return", new Promise(function (resolve, reject) {
                var xhr = new XMLHttpRequest();
                xhr.open(method, url, true);
                if (headers) {
                  Object.keys(headers).forEach(function (key) {
                    xhr.setRequestHeader(key, headers[key]);
                  });
                }
                xhr.responseType = 'text';
                if (typeof expires === 'number') {
                  xhr.timeout = expires * 1000;
                }
                function onabort() {
                  xhr.abort();
                }
                function cleanup() {
                  signal == null || signal.removeEventListener('abort', onabort);
                }
                signal == null || signal.addEventListener('abort', onabort);
                xhr.upload.addEventListener('progress', function (ev) {
                  onProgress(ev);
                });
                xhr.addEventListener('abort', function () {
                  cleanup();
                  reject(createAbortError());
                });
                xhr.addEventListener('timeout', function () {
                  cleanup();
                  var error = new Error('Request has expired');
                  error.source = {
                    status: 403
                  };
                  reject(error);
                });
                xhr.addEventListener('load', function () {
                  cleanup();
                  if (xhr.status === 403 && xhr.responseText.includes('<Message>Request has expired</Message>')) {
                    var error = new Error('Request has expired');
                    error.source = xhr;
                    reject(error);
                    return;
                  }
                  if (xhr.status < 200 || xhr.status >= 300) {
                    var _error = new Error('Non 2xx');
                    _error.source = xhr;
                    reject(_error);
                    return;
                  }

                  // todo make a proper onProgress API (breaking change)
                  onProgress == null || onProgress({
                    loaded: size,
                    lengthComputable: true
                  });

                  // https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/getAllResponseHeaders#examples
                  var arr = xhr.getAllResponseHeaders().trim().split(/[\r\n]+/);
                  // @ts-expect-error null is allowed to avoid inherited properties
                  var headersMap = {
                    __proto__: null
                  };
                  var _iterator = _createForOfIteratorHelper(arr),
                    _step;
                  try {
                    for (_iterator.s(); !(_step = _iterator.n()).done;) {
                      var line = _step.value;
                      var parts = line.split(': ');
                      var header = parts.shift();
                      var value = parts.join(': ');
                      headersMap[header] = value;
                    }
                  } catch (err) {
                    _iterator.e(err);
                  } finally {
                    _iterator.f();
                  }
                  var etag = headersMap.etag,
                    location = headersMap.location;
                  if (method.toUpperCase() === 'POST' && location === null) {
                    // Not being able to read the Location header is not a fatal error.
                    // eslint-disable-next-line no-console
                    console.warn('AwsS3/Multipart: Could not read the Location header. This likely means CORS is not configured correctly on the S3 Bucket. See https://uppy.io/docs/aws-s3-multipart#S3-Bucket-Configuration for instructions.');
                  }
                  if (etag === null) {
                    reject(new Error('AwsS3/Multipart: Could not read the ETag header. This likely means CORS is not configured correctly on the S3 Bucket. See https://uppy.io/docs/aws-s3-multipart#S3-Bucket-Configuration for instructions.'));
                    return;
                  }
                  onComplete == null || onComplete(etag);
                  resolve(_objectSpread(_objectSpread({}, headersMap), {}, {
                    ETag: etag // keep capitalised ETag for backwards compatiblity
                  }));
                });
                xhr.addEventListener('error', function (ev) {
                  cleanup();
                  var error = new Error('Unknown error');
                  error.source = ev.target;
                  reject(error);
                });
                xhr.send(body);
              }));
            case 5:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      function uploadPartBytes(_x6) {
        return _uploadPartBytes.apply(this, arguments);
      }
      return uploadPartBytes;
    }()
  }]);
  return AwsS3Multipart;
}(BasePlugin, _Symbol$for);
export { AwsS3Multipart as default };
function _getTemporarySecurityCredentials2(_x7) {
  return _getTemporarySecurityCredentials3.apply(this, arguments);
}
function _getTemporarySecurityCredentials3() {
  _getTemporarySecurityCredentials3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(options) {
    var _this4 = this;
    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          throwIfAborted(options == null ? void 0 : options.signal);
          if (!(_classPrivateFieldLooseBase(this, _cachedTemporaryCredentials)[_cachedTemporaryCredentials] == null)) {
            _context5.next = 7;
            break;
          }
          // We do not await it just yet, so concurrent calls do not try to override it:
          if (this.opts.getTemporarySecurityCredentials === true) {
            this.assertHost('getTemporarySecurityCredentials');
            _classPrivateFieldLooseBase(this, _cachedTemporaryCredentials)[_cachedTemporaryCredentials] = _classPrivateFieldLooseBase(this, _client)[_client].get('s3/sts', options).then(assertServerError);
          } else {
            _classPrivateFieldLooseBase(this, _cachedTemporaryCredentials)[_cachedTemporaryCredentials] = this.opts.getTemporarySecurityCredentials(options);
          }
          _context5.next = 5;
          return _classPrivateFieldLooseBase(this, _cachedTemporaryCredentials)[_cachedTemporaryCredentials];
        case 5:
          _classPrivateFieldLooseBase(this, _cachedTemporaryCredentials)[_cachedTemporaryCredentials] = _context5.sent;
          setTimeout(function () {
            // At half the time left before expiration, we clear the cache. That's
            // an arbitrary tradeoff to limit the number of requests made to the
            // remote while limiting the risk of using an expired token in case the
            // clocks are not exactly synced.
            // The HTTP cache should be configured to ensure a client doesn't request
            // more tokens than it needs, but this timeout provides a second layer of
            // security in case the HTTP cache is disabled or misconfigured.
            _classPrivateFieldLooseBase(_this4, _cachedTemporaryCredentials)[_cachedTemporaryCredentials] = null;
          }, (getExpiry(_classPrivateFieldLooseBase(this, _cachedTemporaryCredentials)[_cachedTemporaryCredentials].credentials) || 0) * 500);
        case 7:
          return _context5.abrupt("return", _classPrivateFieldLooseBase(this, _cachedTemporaryCredentials)[_cachedTemporaryCredentials]);
        case 8:
        case "end":
          return _context5.stop();
      }
    }, _callee5, this);
  }));
  return _getTemporarySecurityCredentials3.apply(this, arguments);
}
function _uploadLocalFile2(file) {
  var _this3 = this;
  var _this = this;
  return new Promise(function (resolve, reject) {
    var onProgress = function onProgress(bytesUploaded, bytesTotal) {
      _this3.uppy.emit('upload-progress', _this3.uppy.getFile(file.id), {
        // @ts-expect-error TODO: figure out if we need this
        uploader: _this3,
        bytesUploaded: bytesUploaded,
        bytesTotal: bytesTotal
      });
    };
    var onError = function onError(err) {
      _this3.uppy.log(err);
      _this3.uppy.emit('upload-error', file, err);
      _this3.resetUploaderReferences(file.id);
      reject(err);
    };
    var onSuccess = function onSuccess(result) {
      var uploadResp = {
        body: _objectSpread({}, result),
        status: 200,
        uploadURL: result.location
      };
      _this3.resetUploaderReferences(file.id);
      _this3.uppy.emit('upload-success', _classPrivateFieldLooseBase(_this3, _getFile)[_getFile](file), uploadResp);
      if (result.location) {
        _this3.uppy.log("Download ".concat(file.name, " from ").concat(result.location));
      }
      resolve();
    };
    var upload = new MultipartUploader(file.data, _objectSpread({
      // .bind to pass the file object to each handler.
      companionComm: _classPrivateFieldLooseBase(_this3, _companionCommunicationQueue)[_companionCommunicationQueue],
      log: function log() {
        var _this$uppy;
        return (_this$uppy = _this.uppy).log.apply(_this$uppy, arguments);
      },
      getChunkSize: _this3.opts.getChunkSize ? _this3.opts.getChunkSize.bind(_this3) : null,
      onProgress: onProgress,
      onError: onError,
      onSuccess: onSuccess,
      onPartComplete: function onPartComplete(part) {
        _this3.uppy.emit('s3-multipart:part-uploaded', _classPrivateFieldLooseBase(_this3, _getFile)[_getFile](file), part);
      },
      file: file,
      shouldUseMultipart: _this3.opts.shouldUseMultipart
    }, file.s3Multipart));
    _this3.uploaders[file.id] = upload;
    var eventManager = new EventManager(_this3.uppy);
    _this3.uploaderEvents[file.id] = eventManager;
    eventManager.onFileRemove(file.id, function (removed) {
      upload.abort();
      _this3.resetUploaderReferences(file.id, {
        abort: true
      });
      resolve("upload ".concat(removed, " was removed"));
    });
    eventManager.onCancelAll(file.id, function (options) {
      if ((options == null ? void 0 : options.reason) === 'user') {
        upload.abort();
        _this3.resetUploaderReferences(file.id, {
          abort: true
        });
      }
      resolve("upload ".concat(file.id, " was canceled"));
    });
    eventManager.onFilePause(file.id, function (isPaused) {
      if (isPaused) {
        upload.pause();
      } else {
        upload.start();
      }
    });
    eventManager.onPauseAll(file.id, function () {
      upload.pause();
    });
    eventManager.onResumeAll(file.id, function () {
      upload.start();
    });
    upload.start();
  });
}
function _getCompanionClientArgs2(file) {
  var _file$remote;
  return _objectSpread(_objectSpread({}, (_file$remote = file.remote) == null ? void 0 : _file$remote.body), {}, {
    protocol: 's3-multipart',
    size: file.data.size,
    metadata: file.meta
  });
}
AwsS3Multipart.VERSION = packageJson.version;